/* eslint-disable camelcase */
import { type UseMutationResult, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  EsppOfferingPeriodService,
  type Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodCreateDto,
} from '@wealthlane/api-services/wealthlane-award-service';
import { useNavigate } from 'react-router-dom';

const usePostOfferingPeriod = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  events: {
    onSuccess: () => void;
  }
): UseMutationResult<
  | Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodCreateDto
  | undefined,
  unknown,
  any,
  unknown
> => {
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        EsppOfferingPeriodService.postApiAwardApiAwardOfferingPeriod(payload)
      );
    },
    {
      onSuccess: (
        response:
          | Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodCreateDto
          | undefined
      ) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message='Offering period added. ' />);
          events?.onSuccess();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostOfferingPeriod;
